export const PageBreakBlock = {
    block(block){
        return {
            name : 'Page Break' || 'PDF Break',
            fields: block.fields ?? [],
            type: 'page-break' || 'pdf-break',
            uuid: block.uuid ?? 0,
            lock: block.lock ?? 0
        }
    }
}